


export interface CatProbeState {
	showInvalids: boolean,
	neckCircumference: number | null,
	name: string | null,
	email: string | null,
	phoneNumber: string | null,
	catName: string | null,
	
	companyPhoneNumber: string | null,
	companyName: string | null,
	companyStreet: string | null,
	companyCity: string | null,
	companyPostalCode: string | null,
	
	message: string | null,
};

export const initialState: CatProbeState = {
	showInvalids: false,
	neckCircumference: null,
	name: null,
	email: null,
	phoneNumber: null,
	catName: null,
	companyPhoneNumber: null,

	companyName: null,
	companyStreet: null,
	companyCity: null,
	companyPostalCode: null,
	
	message: null,
};